export default {
      id: "just-ai-usage",
      viewBox: "0 0 100 28",
      url: "assets/" + "sprite.svg#just-ai-usage",
      toString: function () {
        return this.url;
      }
    }